import { UtilityService } from '@ecap3/core';

export class DriveFile {
    public ParentId : string;
    public IsFavorite:boolean;
    public OwnerName: string;
    public SharedByUserName: string;
    public ItemId: string;
    public Name: string;
    public Description:string;
    public IconName: string;
    public CreateDate: any;
    public FileStorageId: any;
    public Type: any;
    public FileSizeInKB: number;
    public OriginalArtifactId: any;
    public OrganizationId: any;
    public PublishedOn: string
    public IsPublished: boolean;
    public IsArchived: boolean;
    public sharedToUserId: string;
    public OwnerId: string;
    public Url: string;

    constructor(
        ParentId:string,
        IsFavorite:boolean,
        OwnerName: string,
        SharedByUserName: string,
        sharedToUserId: string,
        OwnerId: string,
        ItemId: string,
        OriginalArtifactId: string,
        Name: string,
        Description:string,
        IconName: string,
        CreateDate: any,
        FileStorageId: any,
        OrganizationId: string,
        FileSizeInByte?: number,
        Type?: string,
        Url?: string,
        PublishedOn?: string,
        IsPublished?: boolean,
        IsArchived?: boolean,
        private utilityService?: UtilityService
    ) {
        this.ParentId = ParentId ;
        this.IsFavorite=IsFavorite;
        this.OwnerName = OwnerName;
        this.SharedByUserName = SharedByUserName;
        this.ItemId = ItemId || this.utilityService.getNewGuid();
        this.sharedToUserId = sharedToUserId;
        this.OwnerId = OwnerId;
        this.OriginalArtifactId = OriginalArtifactId;
        this.Name = Name;
        this.Description = Description;
        this.IconName = IconName;
        this.CreateDate = CreateDate;
        this.FileStorageId = FileStorageId;
        this.Type = Type || 'DriveFile';
        this.OrganizationId = OrganizationId;
        this.FileSizeInKB = Math.floor(FileSizeInByte / 1024) || 0;
        this.OrganizationId = OrganizationId;
        this.PublishedOn = PublishedOn
        this.Url = Url
        this.IsArchived = IsArchived || false;
        this.IsPublished = IsPublished || false;
    }
}
